/* My Services — the secondary button on a service card opens the treatments panel that
   sits under it, and takes the "open" label while it is open.

   Nothing here knows which card it is working on: the button carries the panel's id in
   aria-controls and both labels in data attributes, so a second card with a panel needs
   no extra wiring. The panel is closed with the hidden attribute rather than a class, so
   there is one source of truth for the state — see blocks/service-card.liquid. */

(function () {
  'use strict';

  function setOpen(panel, open) {
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }

    /* Found from the panel rather than passed in, so the editor hook below can reuse
       this without a button to start from. */
    var control = document.querySelector('[data-services-toggle][aria-controls="' + panel.id + '"]');
    if (!control) return;

    control.setAttribute('aria-expanded', open ? 'true' : 'false');

    var label = open ? control.dataset.labelHide : control.dataset.labelShow;
    if (label) control.textContent = label;
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-services-toggle]');
    if (!control) return;

    var panel = document.getElementById(control.getAttribute('aria-controls'));
    if (panel) setOpen(panel, panel.hasAttribute('hidden'));
  });

  /* The treatment cards are blocks nested inside the panel, so with the panel closed the
     theme editor would scroll a merchant to a card they cannot see. Selecting one opens
     the panel for them. */
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest('.services__panel');
    if (panel) setOpen(panel, true);
  });
})();
